import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// .bns-switch: 44x24 track, line-strong, red once checked (accent).
export const Switch: ComponentMultiStyleConfig = {
  parts: ["container", "track", "thumb"],
  baseStyle: {
    track: {
      bg: "lineStrong",
      _checked: { bg: "accent" },
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "focus",
        outlineOffset: "2px",
      },
    },
    thumb: {
      bg: "surface",
    },
  },
  sizes: {
    md: {
      container: {
        "--switch-track-width": "40px",
        "--switch-track-height": "20px",
      },
    },
  },
}
